import * as React from 'react';
import {Field, reduxForm, InjectedFormProps, formValueSelector} from 'redux-form';
import {connect} from 'react-redux';
import {RenderField, Validators, CarCategorySelect} from './Fields/_Fields';
import * as Dictionary from 'Models/Dictionary';
import {withTranslation} from 'react-i18next';
import {RootState} from 'Redux/Reducers/_RootReducer';
import {compose} from 'redux';
import * as TIModule from "Modules/TerminalInstallationModule";
import FileField from "components/Layout/Form/Fields/FileField";

type ConnectedProps = {
    t: Function;
    responseError: {
        errorCode: string;
        errorSubcode: string;
    };
    contactPersonInfo: string;
    status: TIModule.TerminalInstallationEnumTypes.Status;
};

type Props = {
    typeForm: 'edit' | 'add' | 'setDate';
    hideTitle?: boolean;
};

const TerminalInstallationListAddForm = (props: InjectedFormProps<TIModule.Types.TerminalInstallationOrderDto> & ConnectedProps & Props) => {
    const {handleSubmit, t, responseError, typeForm, hideTitle, contactPersonInfo, status} = props;
    const isDeviceChangeOnlyByOrder = typeForm == 'edit' && status === TIModule.TerminalInstallationEnumTypes.Status.INSTALLATION_CONFIRMED;
    const options = Dictionary.GenerateList(Dictionary.CarCategoryArray, 'carDetails');

    return (
        <>
            {!hideTitle &&
            <h3 className="form__title">
                {props.typeForm == 'edit' && t('editTerminalInstallation')}

                {props.typeForm == 'add' && t('addTerminalInstallation')}

                {props.typeForm == 'setDate' && t('setDateTerminalInstallation')}
            </h3>
            }
            <form className="form" onSubmit={handleSubmit}>
                {responseError &&
                <p className="form-field__error mb-20">{t(`errors:${responseError.errorSubcode}`)}</p>}

                <Field
                    name="sellerProposalNumber"
                    disabled={typeForm == 'setDate'}
                    component={RenderField}
                    type="text"
                    placeholder={t('sellerProposalNumber')}
                    label={t('sellerProposalNumber')}
                    e2eId={"sellerProposalNumberInput"}
                    validate={[Validators.required]}
                />
                <div className="form__separation">{t('vehicleDeliveryDetails')}:</div>
                <Field
                    name="carSupplierCompanyName"
                    disabled={typeForm == 'setDate'}
                    component={RenderField}
                    type="text"
                    placeholder={t('companySupplier')}
                    label={t('companySupplier')}
                    e2eId={"carSupplierCompanyNameInput"}
                    validate={[Validators.required]}
                />

                <div className="form-field form-field--clear-margin flex flex--space-between">
                    <Field
                        name="plannedAddress.streetName"
                        disabled={typeForm == 'setDate'}
                        wrapperClassName={'form-field--half'}
                        component={RenderField}
                        type="text"
                        placeholder={t('address')}
                        label={t('address')}
                        e2eId={"addressInput"}
                        validate={[Validators.required]}
                    />
                    <Field
                        name="plannedAddress.houseNo"
                        disabled={typeForm == 'setDate'}
                        wrapperClassName={'form-field--half'}
                        component={RenderField}
                        type="text"
                        placeholder={t('houseNo')}
                        label={t('houseNo')}
                        e2eId={"houseNoInput"}
                        validate={[Validators.required]}
                    />
                </div>

                <div className="form-field form-field--clear-margin flex flex--space-between">
                    <Field
                        name="plannedAddress.postCode"
                        disabled={typeForm == 'setDate'}
                        wrapperClassName={'form-field--half'}
                        component={RenderField}
                        type="text"
                        placeholder={t('postCode')}
                        label={t('postCode')}
                        e2eId={"postCodeInput"}
                        validate={[Validators.required, Validators.postCode]}
                    />
                    <Field
                        name="plannedAddress.city"
                        disabled={typeForm == 'setDate'}
                        wrapperClassName={'form-field--half'}
                        component={RenderField}
                        type="text"
                        placeholder={t('city')}
                        label={t('city')}
                        e2eId={"cityInput"}
                        validate={[Validators.required]}
                    />
                </div>

                <Field
                    name="contactPersonInfo"
                    disabled={typeForm == 'setDate'}
                    component={RenderField}
                    type="text"
                    placeholder={''}
                    label={'Nazwa dostawcy / Osoba do kontaktu'}
                    e2eId={"contactPersonInfo"}
                    validate={[]}
                />
                
                <Field
                    name="carSupplierPhoneNumber"
                    disabled={typeForm == 'setDate'}
                    component={RenderField}
                    type="text"
                    placeholder={t('phone')}
                    label={t('contactPhone')}
                    e2eId={"phoneInput"}
                    validate={[Validators.required, Validators.phone]}
                />

                <Field
                    name="carSupplierEmail"
                    disabled={typeForm == 'setDate'}
                    component={RenderField}
                    type="text"
                    placeholder={t('email')}
                    label={t('email')}
                    e2eId={"emailInput"}
                    validate={[Validators.required, Validators.email]}
                />

                <div className="form__separation">Dane leasingobiorcy:</div>
                <Field
                    name="lesseeName"
                    disabled={typeForm == 'setDate'}
                    component={RenderField}
                    type="text"
                    placeholder={'Nazwa leasingobiorcy'}
                    label={'Nazwa leasingobiorcy'}
                    e2eId={"lesseeNameInput"}
                    validate={[]}
                />

                <Field
                    name="lesseePhoneNumber"
                    disabled={typeForm == 'setDate'}
                    component={RenderField}
                    type="text"
                    placeholder={t('phone')}
                    label={'Telefon leasingobiorcy'}
                    e2eId={"lesseePhoneNumberInput"}
                    validate={[Validators.phone]}
                />

                <Field
                    name="lesseeEmail"
                    disabled={typeForm == 'setDate'}
                    component={RenderField}
                    type="text"
                    placeholder={t('email')}
                    label={'E-mail leasingobiorcy'}
                    e2eId={"lesseeEmailInput"}
                    validate={[Validators.email]}
                />

                <div className="form__separation">{t('informationAboutTheCar')}:</div>
                <Field
                    name="vin"
                    disabled={typeForm == 'setDate'}
                    component={RenderField}
                    type="text"
                    placeholder={t('carDetails:vin')}
                    label={t('carDetails:vin')}
                    e2eId={"vinInput"}
                    validate={[Validators.required]}
                />

                <div className="form-field form-field--clear-margin flex flex--space-between">
                    <Field
                        name="carManufacturer"
                        disabled={typeForm == 'setDate'}
                        wrapperClassName={'form-field--half'}
                        component={RenderField}
                        type="text"
                        placeholder={t('carDetails:carManufacturer')}
                        label={t('carDetails:carManufacturer')}
                        e2eId={"carManufacturerInput"}
                        validate={[Validators.required]}
                    />
                    <Field
                        name="carModel"
                        disabled={typeForm == 'setDate'}
                        wrapperClassName={'form-field--half'}
                        component={RenderField}
                        type="text"
                        placeholder={t('carDetails:carModel')}
                        label={t('carDetails:carModel')}
                        e2eId={"carModelInput"}
                        validate={[Validators.required]}
                    />
                </div>

                <Field
                    name="carCategory"
                    disabled={typeForm == 'setDate'}
                    component={CarCategorySelect}
                    options={options}
                    type="text"
                    placeholder={t('carDetails:vehicleCategory')}
                    label={t('carDetails:vehicleCategory')}
                    e2eId={"carCategoryInput"}
                    validate={[Validators.required]}
                />
                <Field
                  wrapperClassName="teltonika-montage-checkbox"
                  name="teltonikaMontage"
                  id="teltonikaMontage"
                  component={RenderField}
                  type="checkbox"
                  label={t('TELTONIKA_MONTAGE')}
                  e2eId="teltonikaMontage"
                />
                <Field
                  disabled={typeForm != 'add'}
                  name="deviceId"
                  id="deviceId"
                  component={RenderField}
                  type="text"
                  label={t('DEVICE_ID')}
                  e2eId="deviceId"
                />
                {isDeviceChangeOnlyByOrder &&
                <p className="mb-20" date-e2eid="deviceChangeViaNewPanel">{t('DEVICE_CHANGE_VIA_NEW_PANEL')}</p>}
                <Field
                    disabled={typeForm == 'setDate'}
                    name="vinPhoto"
                    id="vinPhoto"
                    component={FileField}
                    type="text"
                    placeholder={t(`noFilesSelected`)}
                    label={t('VIN_PHOTO')}
                    noKey
                    hiddenInput
                />
                <Field
                    disabled={typeForm == 'setDate'}
                    name="frontPhoto"
                    id="frontPhoto"
                    component={FileField}
                    type="text"
                    placeholder={t(`noFilesSelected`)}
                    label={t('CAR_FRONT_PHOTO')}
                    noKey
                    hiddenInput
                />
                <Field
                    disabled={typeForm == 'setDate'}
                    name="backPhoto"
                    id="backPhoto"
                    component={FileField}
                    type="text"
                    placeholder={t(`noFilesSelected`)}
                    label={t('CAR_BACK_PHOTO')}
                    noKey
                    hiddenInput
                />
                <Field
                    disabled={typeForm == 'setDate'}
                    name="dashboardPhoto"
                    id="dashboardPhoto"
                    component={FileField}
                    type="text"
                    placeholder={t(`noFilesSelected`)}
                    label={t('DASHBOARD_PHOTO')}
                    noKey
                    hiddenInput
                />
            </form>
        </>
    );
};

function mapStateToProps(state: RootState) {
    return {
        responseError: state.errorStore.responseError.data,
        status: formValueSelector('terminalInstallationListAddForm')(state, 'status'),
        activelanguage: state.viewManagementStore.activeLanguage
    };
}


export default compose(
    connect(mapStateToProps),
    withTranslation(['forms', 'errors', 'dictionary', 'carDetails']),
    reduxForm({
        form: 'terminalInstallationListAddForm',
        enableReinitialize: true,
        keepDirtyOnReinitialize: true
    })
)(TerminalInstallationListAddForm) as React.ComponentClass<any>



// WEBPACK FOOTER //
// ./src/components/Layout/Form/TerminalInstallationListAddForm.tsx